import {
  ADS_ANALYTICS_NAMESPACE,
  OTT_ANALYTICS_NAMESPACE,
  ROI_ANALYTICS_NAMESPACE,
  SEO_ANALYTICS_NAMESPACE,
  SKAN_UNIFIED_NAMESPACE,
  SOURCE_ANALYTICS_NAMESPACE,
  TRUEVIEW_ANALYTICS_NAMESPACE,
} from './shareableReports';

export const LIGHTWEIGHT_FILTERS_NAMESPACES_WHITELIST = [
  ADS_ANALYTICS_NAMESPACE,
  OTT_ANALYTICS_NAMESPACE,
  SEO_ANALYTICS_NAMESPACE,
  TRUEVIEW_ANALYTICS_NAMESPACE,
  SKAN_UNIFIED_NAMESPACE,
  SOURCE_ANALYTICS_NAMESPACE,
  ROI_ANALYTICS_NAMESPACE,
];
